export const desactivar:any=
{
    Activo:false,
    mensaje:""
}